import { configureStore } from "@reduxjs/toolkit";
import timesheetReducer from "../features/timesheet/timesheetSlice";
import breakTypeReducer from "../features/admin/breakType/breakTypeSlice";
import employeeReducer from "../features/admin/employee/employeeSlice";
import taskReducer from "../features/project/TaskSlice";
import projectReducer from "../features/project/projectSlice";
import timeoffrequestReducer from "../features/timeoffrequest/timeoffrequestSlice";
import locationReducer from "../features/admin/location/LocationSlice"
import taskTypeSlice from "../features/admin/taskType/TaskTypeSlice";
import projectTypeSlice from "../features/admin/projectType/ProjectTypeSlice";
import employeeTypeSlice from "../features/admin/employeeType/EmployeeTypeSlice";
import  statusSlice  from "../features/admin/status/StatusSlice";
import PrioritySlice from "../features/admin/priority/PrioritySlice";
import timeOffTypeSlice from "../features/admin/timeOffTypes/TimeOffTypeSlice";
import expenseCategorySlice from "../features/admin/expenseCategory/expenseCategorySlice";
import currenciesSlice from "../features/admin/currencies/CurrenciesSlice";
import CurrencyExchangeRateSlice from "../features/admin/currencyExchangeRates/CurrencyExchangeRateSlice";
import ApiRecordLogSlice from "../features/admin/apiRecordLogs/ApiRecordLogSlice";
import WebHookReceiverLogSlice from "../features/admin/webHookReceiverLogs/WebHookReceiverLogSlice";
import WebHookReceiverLogsAuditSlice from "../features/admin/webHookReceiverLogsAudit/WebHookReceiverLogsAuditSlice";
import WebHookSlice from "../features/admin/webhooks/WebHookSlice";
import WebHookSenderLogSlice from "../features/admin/webHookSenderLogs/WebHookSenderLogSlice";
import externalUserSlice from "../features/admin/externalUsers/externalUserSlice";
import EMailNotificationPreferencesSlice from "../features/admin/eMailNotificationPreferences/EMailNotificationPreferencesSlice";
import TimeOffPoliciesSlice from "../features/admin/timeOffPolicies/TimeOffPoliciesSlice";

import CustomFieldSlice from "../features/admin/customFields/CustomFieldSlice";
import timesheetPeriodTypeReducer from "../features/admin/timesheetPeriodTypes/TimesheetPeriodTypeSlice";
import accountApprovalReducer from "../features/admin/accountApprovals/AccountApprovalSlice";
import integrationReducer from "../features/admin/integrations/IntegrationSlice";
import expenseEntryArchiveReducer from "../features/admin/expenseEntryArchives/ExpenseEntryArchiveSlice";
// import clientContactReducer from "../features/admin/clientContacts/ClientContactSlice";
import clientContactReducer from "../features/client/clientContacts/ClientContactSlice";
// import clientDepartmentReducer from "../features/admin/clientDepartment/ClientDepartmentSlice";
import clientDepartmentReducer from "../features/client/clientDepartment/ClientDepartmentSlice";
import customReportViewReducer from "../features/report/customReportView/CustomReportViewSlice";
import customReportDesignReducer from "../features/report/customReportDesign/CustomReportDesignSlice";
import myReportsReducer from "../features/report/myReports/MyReportsSlice";
import accountReportPermissionReducer from "../features/report/accountReportPermission/AccountReportPermissionSlice";
import attendanceReducer from "../features/attendance/AttendanceSlice";
import timeOffApprovalReducer from "../features/approvals/timeOffApproval/TimeOffApprovalSlice";
import attachmentReducer from "../features/attachment/AttachmentSlice";
import rolePermissionReducer from "../features/admin/rolePermissions/RolePermissionSlice";
import paymentMethodReducer  from "../features/admin/paymentmethod/paymentMethodSlice"; 
import taxZoneReducer from "../features/admin/taxZone/taxZoneSlice"; 
import costCenterReducer from "../features/admin/costCenter/costCenterSlice"; 
import holidayTypeReducer from "../features/admin/holidayType/holidayTypeSlice"; 
import billingTypeReducer from  "../features/admin/billingType/billingTypeSlics";
import absenceTypeReducer from "../features/admin/absenceType/absenceTypeSlice";
import holidayTypeDetailReducer from "../features/admin/holidayTypeDetail/holidayTypeDetailSlice";
import expensePolicyReducer from "../features/admin/expensePolicy/expensePolicySlice";
import expensePolicyDetailReducer from "../features/admin/expensePolicyDetail/expensePolicyDetailSlice";
import expensePolicyRuleReducer from "../features/admin/expensePolicyRule/expensePolicyRuleSlice";
import expensePolicyPerDiemReducer from "../features/admin/expensePolicyPerDiem/expensePolicyPerDiemSlice";
import expensePolicyLockingExpensesReducer from "../features/admin/expensePolicyLockingExpenses/expensePolicyLockingExpensesSlice";
import accountPreferenceReducer from "../features/admin/accountPreferences/accountPreferenceSlice";
import emailNotificationPreferenceReducer from "../features/admin/emailNotificationPreference/emailNotificationPreferenceSlice";
import manageTerminologyReducer from "../features/admin/manageTerminology/manageTerminologySlice";
import featureManagementReduce from  "../features/admin/featureManagement/featureManagementSlice";
import paidThroughReducer from  "../features/admin/paidThrough/paidThroughSlice";
import AccountClientReducer from "../features/client/AccountClientSlice";
import PayCodeReducer from "../features/admin/payCode/payCodeSlice";
import PayRuleReducer from "../features/admin/payRule/payRuleSlice";
import importExportReducer from "../features/admin/importExport/importExportSlice";
import ExpenseReducer from "../features/expense/expenseSlice";
import departmentReducer from "../features/admin/Department/departmentSlice";
import departmentsReducer from "../features/admin/departments/departmentsSlice";
import roleReducer from "../features/admin/role/roleSlice"
import worktypeReducer from "../features/admin/worktype/worktypeSlice"
import taxcodeReducer from "../features/admin/taxcode/taxcodeSlice"
import expensetypeReducer from "../features/admin/expensetype/expensetypeSlice"
import workingdaytypeReducer from "../features/admin/workingdaytypes/workingdaytypeSlice"
import GlobalReducer from "../common/GlobalSlice"
import holidaySelectReducer from "../features/admin/holidaySelect/holidaySelectSlice"
import shiftReducer from "../features/admin/shift/ShiftSlice"
import profileReducer from "../features/profile/ProfileSlice"
import licenseActivationReducer from "../features/admin/licenseActivation/LicenseActivationSlice"
import breakReducer from "../features/admin/break/breakSlice"
import expenseApprovalReducer from "../features/approvals/expenseApproval/ExpenseApprovalSlice";
import billingRateReducer from "../features/billing/billingRateSlice"
import tasksReducer from "../features/project/TasksSlice"
import milestoneReducer from "../features/project/MilestoneSlice"
import taskRequestHoursReducer from "../features/taskrequesthours/taskRequestHoursSlice"
import employeeTaskReducer from "../features/admin/employee/EmployeeTaskSlice"
import employeeProjectReducer from "../features/admin/employee/EmployeeProjectSlice"
import employeeTimeOffReducer from "../features/admin/employee/EmployeeTimeOffSlice"
import auditReducer from "../features/audit/AccountAuditSlice"
import TimeEntryArchiveSlice from "../features/admin/timeEntryArchives/TimeEntryArchiveSlice"
import ExpenseBillingWorksheetReducer from "../features/billing/expenseBillingWorkssheet/expenseBillingSlice"
import TimeBillingWorksheetReeducer from "../features/billing/timeBillingWorkssheet/timeBillingSlice"
/* import InvoiceTemplateReducer from "../features/admin/invoiceTemplate/invoiceTemplateSlice"; */
import InvoiceTemplateReducer from "../features/admin/invoiceTemplate/invoiceTemplateSlice"
import invoiceBillingReducer from "../features/billing/invoiceBillingSlice"
import quicksBookLogReducer from "../features/admin/accountQBOnline/accountQBLog/QuicksBookLogSlice"
import calendarReducer  from "../features/calendar/CalendarSlice";
import boardReducer from "../features/project/Board/BoardSlice";
import schedulerReducer from '../features/Scheduler/SchedulerSlice';
import dashboardReducer from '../features/dashboard/dashboardSlice';
import GeofencingReduvcer  from "../features/admin/geofencingSetting/GeofencingSlice";
import attendancePolicyReducer  from "../features/admin/attendancePolicy/AttendancePolicySlice";


export const store = configureStore({
    reducer: {
        timesheet: timesheetReducer,
        breakType:breakTypeReducer,
        break: breakReducer,
        task: taskReducer,
        project:projectReducer,
        employee:employeeReducer,
        timeoffrequest:timeoffrequestReducer,
        location:locationReducer,
        taskType:taskTypeSlice,
        projectType:projectTypeSlice,
        employeeType:employeeTypeSlice,
        status:statusSlice,
        priority:PrioritySlice,
        timeOffType:timeOffTypeSlice,
        expenseCategory:expenseCategorySlice,
        currencies:currenciesSlice,
        currencyExchangeRate:CurrencyExchangeRateSlice,
        apiRecordLog:ApiRecordLogSlice,
        webHookReceiverLog:WebHookReceiverLogSlice,
        webHookReceiverLogAudit:WebHookReceiverLogsAuditSlice,
        webHook:WebHookSlice,
        webHookSenderLog:WebHookSenderLogSlice,
        externalUser:externalUserSlice,
        eMailNotificationPreferences:EMailNotificationPreferencesSlice,
        timeOffPolicy:TimeOffPoliciesSlice,
        customField:CustomFieldSlice,
        timesheetPeriodType:timesheetPeriodTypeReducer,
        accountApproval:accountApprovalReducer,
        integration:integrationReducer,
        expenseEntryArchive:expenseEntryArchiveReducer,
        clientContact:clientContactReducer,
        clientDepartment:clientDepartmentReducer,
        customReportView:customReportViewReducer,
        customReportDesign:customReportDesignReducer,
        myReports:myReportsReducer,
        accountReportPermission:accountReportPermissionReducer,
        attendance:attendanceReducer,
        timeOffApproval:timeOffApprovalReducer,
        attachment:attachmentReducer,
        rolePermission:rolePermissionReducer,
        paymentMethod:paymentMethodReducer,
        taxZone:taxZoneReducer,
        costCenter:costCenterReducer,
        holidayType:holidayTypeReducer,
        billingType:billingTypeReducer,
        absenceType:absenceTypeReducer,
        holidayTypeDetail:holidayTypeDetailReducer,
        expensePolicy:expensePolicyReducer,
        expensePolicyDetail:expensePolicyDetailReducer,
        expensePolicyRule:expensePolicyRuleReducer,
        expensePolicyPerDiem:expensePolicyPerDiemReducer,
        expensePolicyLockingExpenses:expensePolicyLockingExpensesReducer,
        accountPreferences:accountPreferenceReducer,
        emailNotificationPreference:emailNotificationPreferenceReducer,
        manageTerminology:manageTerminologyReducer,
        featureManagement:featureManagementReduce,
        paidThrough:paidThroughReducer,
        accountClient:AccountClientReducer,
        payCode:PayCodeReducer,
        payRule:PayRuleReducer,
        importExport:importExportReducer,
        expense:ExpenseReducer,
        department:departmentReducer,
        departments:departmentsReducer,
        role:roleReducer,
        worktype:worktypeReducer,
        taxcode:taxcodeReducer,
        expensetype:expensetypeReducer,
        workingdaytype:workingdaytypeReducer,
        globalState:GlobalReducer, 
        holidaySelect:holidaySelectReducer,
        shift:shiftReducer,
        profile:profileReducer,
        licenseActivation : licenseActivationReducer,
        expenseApproval:expenseApprovalReducer,
        billingRate: billingRateReducer,
        tasks: tasksReducer,
        milestone: milestoneReducer,
        taskRequestHours : taskRequestHoursReducer,
        employeeTask: employeeTaskReducer,
        employeeProject:employeeProjectReducer,
        employeeTimeOff:employeeTimeOffReducer,
        audit:auditReducer,
        timeEntryArchive:TimeEntryArchiveSlice,
        expenseBillingWorksheet:ExpenseBillingWorksheetReducer,
        timeBillingWorksheet:TimeBillingWorksheetReeducer,
        invoiceTemplate:InvoiceTemplateReducer,
        invoiceBilling:invoiceBillingReducer,
        quicksBookLog:quicksBookLogReducer,
        calendar: calendarReducer,
        board: boardReducer,
        scheduler: schedulerReducer,
        dashboard: dashboardReducer,
        geofencing: GeofencingReduvcer,
        attendancePolicy:attendancePolicyReducer
    },
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
          serializableCheck: false,
        })
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch